import Badge from './Badge';

export * from './Badge';

export default Badge;
